import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { WAREHOUSES_PATH } from '../../core/constants';

export const getWarehouseStockSummariesAction = createAsyncThunk(
    'inventory/getWarehouseStockSummariesAction',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ WAREHOUSES_PATH }/stock-summary`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getWarehouseStockSummariesSlice = createSlice({
    name: 'getWarehouseStockSummariesSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getWarehouseStockSummariesAction.pending, () => STATE__API__STARTED);
        builder.addCase(getWarehouseStockSummariesAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getWarehouseStockSummariesAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getWarehouseStockSummariesState = (state) => state.inventory.getWarehouseStockSummaries;
export default getWarehouseStockSummariesSlice.reducer;
